import React, { Fragment } from "react";
import ModalModern from "../../../../../../components/ui/popup/ModalModern";
import ModernPopupHeader from "../../../../../../components/ui/popup/common/ModernPopupHeader";
import ModernPopupBody from "../../../../../../components/ui/popup/common/ModernPopupBody";
import FiSubscriptionPlans from "../../../../financial-insights/common/FiSubscriptionPlans";

function UpgradePlanPopup({
  isOpen,
  onClose,
  featureData,
  content,
  currentSubscriptionUuid,
}) {
  if (!isOpen) return null;

  return (
    <Fragment>
      <ModalModern onClose={onClose}>
        <ModernPopupHeader onClose={onClose}>
          <div className="header-content-modern-row">
            <h3 className="transaction-popup-title">Subscription Plans</h3>
          </div>
        </ModernPopupHeader>
        <ModernPopupBody>
          <FiSubscriptionPlans
            featureData={featureData}
            content={content}
            allowedPlanCodes={["fi_paid_basic"]}
            isPopup={true}
            isUpgrade={true}
            currentSubscriptionUuid={currentSubscriptionUuid}
          />
        </ModernPopupBody>
      </ModalModern>
    </Fragment>
  );
}

export default UpgradePlanPopup;
